import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export class DynamicModel {
  constructor(ModelsModel, model) {
    _defineProperty(this, "Models", {
      fieldName: 'models',
      content: {}
    });
    _defineProperty(this, "CreatedModels", {
      fieldName: 'models_created',
      content: []
    });
    this.Models.model = new ModelsModel(model, {
      perPage: 10
    });
    this.CreatedModels.model = model;
  }
  getModelPagination() {
    var _this$Models;
    return (_this$Models = this.Models) === null || _this$Models === void 0 ? void 0 : _this$Models.content;
  }
  getModels() {
    var _this$Models2;
    return (_this$Models2 = this.Models) === null || _this$Models2 === void 0 ? void 0 : _this$Models2.content;
  }
  getCreatedModels() {
    var _this$CreatedModels$c, _this$CreatedModels;
    return (_this$CreatedModels$c = (_this$CreatedModels = this.CreatedModels) === null || _this$CreatedModels === void 0 ? void 0 : _this$CreatedModels.content) !== null && _this$CreatedModels$c !== void 0 ? _this$CreatedModels$c : [];
  }
  getCreatedModel() {
    var _this$CreatedModels$c2, _this$CreatedModels2;
    return ((_this$CreatedModels$c2 = (_this$CreatedModels2 = this.CreatedModels) === null || _this$CreatedModels2 === void 0 ? void 0 : _this$CreatedModels2.content) !== null && _this$CreatedModels$c2 !== void 0 ? _this$CreatedModels$c2 : []).first();
  }
}
export default DynamicModel;